const numberRangeValueValidator = (string: string) => {
  const lastCharacter = string.length >= 1 ? string.charAt(string.length -1) : ""
  const isNumber = /^\d+$/.test(lastCharacter)
  if(isNumber) return "Das letzte Zeichen darf keine Zahl sein."
}

export default numberRangeValueValidator